import { N13_02 } from "./N13_02";

export const N13_01 = {
  selectedValueColumn: "Title",
  selectedTitle: "Region",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Region",
        binding: {
          data: {
            columns: [
              {
                name: "Region",
                columnName: "RegionName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Completed",
                columnName: "CompletedAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Total Accounts",
                columnName: "TotalAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Frequency",
                columnName: "CallFrequency",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "RegionName",
            endpoint: "N13.1",
            parameters: [
                { key: "CycleCode", value: "CP1" },
                { key: "CycleYear", value: "2026" },
            ],
          },
          context: {
            point: {
              onClick: N13_02,
            },
          },
        },
      },
    },
  ],
};